import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

import Home from "@/pages/Home";
import Menu from "@/pages/Menu";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import TrackOrder from "@/pages/TrackOrder";
import Account from "@/pages/Account";
import Rooms from "@/pages/Rooms";
import Contact from "@/pages/Contact";
import AuthCallback from "@/pages/AuthCallback";
import OwnerDashboard from "@/pages/OwnerDashboard";

function Router() {
  const loc = useLocation();
  // Handle OAuth callback (session_id in URL fragment) FIRST, before normal routing
  if (loc.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order-success/:orderNumber" element={<OrderSuccess />} />
        <Route path="/track" element={<TrackOrder />} />
        <Route path="/account" element={<Account />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/owner" element={<OwnerDashboard />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <CartDrawer />
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Router />
            <Toaster richColors theme="dark" position="top-right" />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}
